type Config = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  STRIPE_V2?: any
}

const lite = {
  primaryHeader: 'Lite',
  importedLeads: 'Prospect ENGAGE™',
  templates: 6,
  sends: 'Unlimited',
  onboarding: 'Basic',
  templateAssist: 'Access to Template Assist',
  wingmanAccess: 'our Success Wingman™ Team',
}

// trigger build
const pro = {
  primaryHeader: 'Pro',
  importedLeads: 'Prospect ENGAGE™',
  templates: 12,
  sends: 'Unlimited',
  onboarding: 'Pro',
  templateAssist: 'Access to Template Assist',
  wingmanAccess: 'Dedicated Success Wingman™',
}

const autopilot = {
  primaryHeader: 'AutoPilot',
  importedLeads: 'Prospect ENGAGE™',
  templates: 24,
  sends: 'Unlimited',
  onboarding: 'Concierge',
  templateAssist: 'Content Consulting Services',
  wingmanAccess: 'Concierge Success Wingman™',
}

const envs = {
  dev: {
    Monthly: [
      {
        ...lite,
        id: 'price_1HqOMiBQ2V0NM2d5qw6af6GO',
        price: 298,
      },
      {
        ...pro,
        id: 'price_1HqONfBQ2V0NM2d55Xccobq9',
        price: 498,
      },
      {
        ...autopilot,
        id: 'price_1HqOOPBQ2V0NM2d59LXajCrd',
        price: 798,
      },
    ],
    Yearly: [
      {
        ...lite,
        id: 'price_1HqOMiBQ2V0NM2d5TW7dSBQX',
        price: 225,
        stripeDescription: 'when you pre-pay $2700 for 12 months',
      },
      {
        ...pro,
        id: 'price_1HqONfBQ2V0NM2d5KjnOfDSV',
        price: 425,
        stripeDescription: 'when you pre-pay $5100 for 12 months',
      },
      {
        ...autopilot,
        id: 'price_1HqOOPBQ2V0NM2d5pg1IrztJ',
        price: 725,
        stripeDescription: 'when you pre-pay $8700 for 12 months',
      },
    ],
  },
  beta: {
    Monthly: [
      {
        ...lite,
        id: 'price_1HDG4xBQ2V0NM2d53F9kGW12',
        price: 298,
        stripeDescription: 'Paid Monthly -6 Month Commitment',
      },
      {
        ...pro,
        id: 'price_1HDGABBQ2V0NM2d5gU6ZvPJB',
        price: 498,
        stripeDescription: 'Paid Monthly -6 Month Commitment',
      },
      {
        ...autopilot,
        id: 'price_1HDG8QBQ2V0NM2d5tsHxwLc4',
        price: 798,
        stripeDescription: 'Paid Monthly -6 Month Commitment',
      },
    ],
    Yearly: [
      {
        ...lite,
        id: 'price_1HDG4xBQ2V0NM2d5pyejjkzU',
        price: 225,
        stripeDescription: 'Per Month - Billed Annually',
      },
      {
        ...pro,
        id: 'price_1HDGACBQ2V0NM2d5JkiqafFL',
        price: 425,
        stripeDescription: 'Per Month - Billed Annually',
      },
      {
        ...autopilot,
        id: 'price_1HDG8QBQ2V0NM2d5155NitXQ',
        price: 725,
        stripeDescription: 'Per Month - Billed Annually',
      },
    ],
  },
}

const dev: Config = {
  STRIPE_V2: { ...envs.dev },
}

const beta: Config = {
  STRIPE_V2: { ...envs.beta },
}

const prod: Config = {
  STRIPE_V2: { ...envs.beta },
}

// Default to dev if not set
export const getConfig = (): Config => {
  switch (process.env.REACT_APP_STAGE) {
    case 'prod':
      // eslint-disable-next-line no-console
      console.log = (): void => {}
      return prod
    case 'beta':
      // eslint-disable-next-line no-console
      // console.log = (): void => {}
      return beta
    default:
      return {
        ...dev,
      }
  }
}

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...getConfig(),
}
